import { Text, type TextProps } from '@mantine/core'
import type { ReactNode, Ref } from 'react'

// The light/dark values behind these tokens live in cssVariablesResolver in src/theme.ts.
// A bare var() rather than light-dark(): happy-dom drops light-dark() from inline styles,
// which would make the colour untestable.
const STATUS_COLOR = {
  error: 'var(--mantine-color-error)',
  success: 'var(--status-success-color)',
} as const

export interface StatusMessageProps extends TextProps {
  status: 'error' | 'success'
  // Defaults to alert/status by status; override where a second live region would collide.
  role?: 'alert' | 'status'
  children: ReactNode
  // Passed through to the text element, for callers that need to move focus to it.
  ref?: Ref<HTMLParagraphElement>
}

// Single source of truth for message colour: errors red, successes green, in both schemes.
export function StatusMessage({ status, role, children, ...props }: Readonly<StatusMessageProps>) {
  return (
    <Text fz="sm" {...props} c={STATUS_COLOR[status]} role={role ?? (status === 'error' ? 'alert' : 'status')}>
      {children}
    </Text>
  )
}
